// Read-aloud for the engineer PWA (Session ADM accessibility): a thin, safe wrapper over the
// Web Speech API. PROGRESSIVE ENHANCEMENT ONLY -- where the browser has no speechSynthesis the
// feature is silently absent (speechAvailable() gates the button's render) and nothing breaks.
// Never throws: an engineer mid-checklist must never lose work to a speech quirk.

export function speechAvailable(): boolean {
  try {
    return typeof window !== "undefined" && "speechSynthesis" in window && typeof SpeechSynthesisUtterance !== "undefined";
  } catch {
    return false;
  }
}

// Speak a short text aloud, cancelling anything already speaking (a second tap on another
// item replaces the first rather than queueing). Best-effort, silent on any failure.
export function speak(text: string): void {
  if (!speechAvailable()) return;
  try {
    window.speechSynthesis.cancel();
    const u = new SpeechSynthesisUtterance(text);
    u.lang = "en-GB";
    window.speechSynthesis.speak(u);
  } catch {
    /* silent: read-aloud is an enhancement, never a failure path */
  }
}
